import { observable, action, runInAction, computed } from 'mobx'
import { message } from 'antd'
import { json, get } from '../../../utils/ajax'

class MotorcycleTypeStore {
    @observable loading
    @observable modal
    @observable list
    @observable pagination
    @observable carseries
    @observable forms

    constructor () {
        this.loading = false
        this.modal = 'hide'
        this.list = []
        this.pagination = {}
        this.carseries = []
        this.forms = {}
    }

    /**
     * 初始化页面
     */
    @action
    initListMotorcycleType = async (page,value) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        let search = value || ''
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/motorcycleType`, {
            page: page,
            motorcycleTypeCode: search
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.list = res.content
            this.pagination = {
                results: res.size,
                page: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
        })
    }

    /**
     * 初始化车系下拉框
     * 展开编辑框
     */
    @action
    initCarseries = async () => {
        runInAction(() => {
            this.loading = true
            this.forms = {}
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/carseries:search?size=100`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.carseries = res.content
            this.loading = false
            this.modal = 'show'
        })
    }

    /**
     * 平行化表单，传值给form
     */
    @computed
    get fields () {
        let fields = {
            id:{value: this.forms.id},
            carSeriesId: {value: this.forms.carSeriesId},
            motorcycleTypeCode: {value: this.forms.motorcycleTypeCode},
            engine: {value: this.forms.engine},
            emission: {value: this.forms.emission},
            year: {value: this.forms.year},
            transmission: {value: this.forms.transmission},
            defaultName: {value: this.forms.defaultName},
            defaultDescription: {value: this.forms.defaultDescription},
            defaultConfig: {value: this.forms.defaultConfig},
            defaultConfigName: {value: this.forms.defaultConfigName},
            defaultDriveType: {value: this.forms.defaultDriveType}
        }
        return fields
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onFormsChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let forms = {
            id:fields.id.value,
            carSeriesId: fields.carSeriesId.value,
            motorcycleTypeCode: fields.motorcycleTypeCode.value,
            engine: fields.engine.value,
            emission: fields.emission.value,
            year: fields.year.value,
            transmission: fields.transmission.value,
            defaultName: fields.defaultName.value,
            defaultDescription: fields.defaultDescription.value,
            defaultConfig: fields.defaultConfig.value,
            defaultConfigName: fields.defaultConfigName.value,
            defaultDriveType: fields.defaultDriveType.value
        }
        this.forms = forms
    }

    /**
     * 新增车型 + 修改车型
     */
    @action
    saveMotorcycleType = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.forms.id) {
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/motorcycleType/save`,this.forms)
            if (res && res.status >= 400) {
                message.error('新增失败')
                return
            } else {
                runInAction(() => {
                    this.modal = 'hide'
                    this.forms = {}
                    this.loading = false
                })
            }
        }else {
            const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/motorcycleType/update`, this.forms)
            if (res && res.status >= 400) {
                message.error('修改失败')
                return
            } else {
                runInAction(() => {
                    this.modal = 'hide'
                    this.forms = {}
                    this.loading = false
                })
            }
        }
        await this.initListMotorcycleType(this.page)
    }

    /**
     * 显示和关闭form编辑框
     */
    @action
    showModal = (flag) => {
        runInAction(() => {
            this.loading = true
            this.modal = flag ? 'show' : 'hide'
            this.loading = false
        })
    }

    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action
    initMotorcycleType = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/motorcycleType/searchOne/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.initCarseries()
            this.forms = res.data
            this.loading = false
            this.modal = 'show'
        })
        await this.initListMotorcycleType(this.page)
    }

    /**
     * 刪除
     */
    @action
    deleteMotorcycleType = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/motorcycleType/delete/${id}`)
        if (res && res.status >= 400) {
            return
        }
        runInAction(() => {
            this.loading = false
        })
        if(this.list.length === 1){
            await this.initListMotorcycleType(this.pagination.page -1)
        }else{
            await this.initListMotorcycleType(this.pagination.page)
        }
    }

    /**
     * 启用
     */
    @action
    enableMotorcycleType= async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/motorcycleType/enable/${id}`)
        if (res && res.status >= 400) {
            message.error('启用失败')
            return
        }
        runInAction(() => {
            this.loading = false
        })
        await this.initListMotorcycleType(this.page)
    }

    /**
     * 停用
     */
    @action
    disableMotorcycleType= async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/motorcycleType/disable/${id}`)
        if (res && res.status >= 400) {
            message.error('停用失败')
            return
        }
        runInAction(() => {
            this.loading = false
        })
        await this.initListMotorcycleType(this.page)
    }
}
export default new MotorcycleTypeStore()


// WEBPACK FOOTER //
// ./src/Backend/common/MotorcycleType/store.js